// useStepStore.ts
import { create } from "zustand";

type Step = {
  id: number;
  label: string;
  path: string;
  icon: string;
  isAccessible: boolean;
  isCompleted: boolean;
};

interface JourneyState {
  // agentType: string | null;
  currentStep: number;
  totalSteps: Step[];
  setJourneyStep: (steps: Step[]) => void;
  canAccessStep: (stepId: number) => boolean;
}

const useJourneyStore = create<JourneyState>((set, get) => ({
  totalSteps: [],
  currentStep: 0,
  // agentType: null,

  setJourneyStep: (steps) => set({ totalSteps: steps }),

  canAccessStep: (stepId) => {
    const { totalSteps } = get();

    const step = totalSteps.find((s) => s.id === stepId);
    return step ? step.isAccessible : false;
  },
}));

export default useJourneyStore;
